import u from "classnames";
import t, { useState as D, useCallback as V, useMemo as l } from "react";
import { Price as j } from "../price/price.esm.js";
import { ProductImage as p } from "../product-image/product-image.esm.js";
import { PromoIdentifier as q } from "../promo-identifier/promo-identifier.esm.js";
import { Rating as B } from "../rating/rating.esm.js";
import { Save as G } from "../save/save.esm.js";
import { TypographyComponent as g } from "../typography/typography-component.esm.js";
import { ColourSwatch as H } from "./colour-swatch.esm.js";
import { imageSources as J } from "./config.esm.js";
import { SkeletonCard as K } from "./skeleton-card.esm.js";
import { ListViewProductCard as he } from "./list-view/list-view-product-card.esm.js";
const O = "_productCard_gvf85_1", Q = "_productCard__link_gvf85_7", U = "_productCard__brand_gvf85_24", W = "_productCard__title_gvf85_36", X = "_productCard__price_gvf85_46", Y = "_productCard__saveForLater_gvf85_50", Z = "_productCard__imageSpacing_gvf85_71", _ = {
  productCard: O,
  productCard__link: Q,
  productCard__brand: U,
  productCard__title: W,
  productCard__price: X,
  productCard__saveForLater: Y,
  productCard__imageSpacing: Z
}, P = (i) => typeof i == "string" && i.length > 1, ee = { xxs: "small", m: "medium", l: "large" }, ae = { xxs: "small", m: "medium" };
function de({
  catalogueId: i = "",
  title: v = "",
  brand: C = "",
  productUrl: k = "#",
  isSkeleton: w = !1,
  variant: n = "complex",
  image: d = {
    url: void 0,
    altText: void 0,
    isAltReal: !1,
    disabledLazy: !1,
    fetchPriority: void 0
  },
  price: a = {
    current: 0,
    showCurrentPriceFrom: !1,
    previous: 0,
    showPreviousPriceFrom: !1,
    saving: 0,
    showSave: !0,
    isEuro: !1
  },
  sfl: r = {
    saveCallback: null,
    isSaved: !1
  },
  stars: c = {
    rating: 0,
    reviewText: ""
  },
  swatches: z = [],
  promotionIdentifier: m = {
    displayName: "",
    colour: "black"
  },
  dataTestId: L = null,
  className: F,
  slotProps: e,
  ...f
}) {
  var S, h, x, N, E;
  const [T, s] = D(r == null ? void 0 : r.isSaved), I = P(d == null ? void 0 : d.altText) ? d == null ? void 0 : d.altText : `Missing image for: ${v}`, A = V(
    (M, re, b) => {
      var y;
      M.preventDefault(), s(b), (y = r == null ? void 0 : r.saveCallback) == null || y.call(r, b);
    },
    [r]
  ), R = l(
    () => n === "simple" ? "m1" : { xxs: "m1", m: "m1", l: "1" },
    [n]
  ), o = l(
    () => n === "simple" ? "m1" : { xxs: "m1", m: "m1", l: "1" },
    [n]
  ), $ = l(
    () => n === "simple" ? "s" : { xxs: "xs", m: "xs", l: "s" },
    [n]
  );
  return w ? /* @__PURE__ */ t.createElement(K, { ...f }) : /* @__PURE__ */ t.createElement(
    "div",
    {
      className: u(_.productCard, F, "fuse-product-card"),
      "data-testid": L || "fuse-product-card-data-testid",
      "data-tagg-id": i || void 0,
      ...f
    },
    /* @__PURE__ */ t.createElement(
      "a",
      {
        href: k,
        className: u(_.productCard__link, "fuse-product-card__link"),
        "data-testid": "fuse-product-card__link"
      },
      /* @__PURE__ */ t.createElement(
        p,
        {
          alt: I,
          src: d == null ? void 0 : d.url,
          lazy: !(d != null && d.disabledLazy),
          isAltReal: d == null ? void 0 : d.isAltReal,
          sources: J,
          fetchPriority: d == null ? void 0 : d.fetchPriority,
          ...e == null ? void 0 : e.productImage
        }
      ),
      (m == null ? void 0 : m.displayName) && /* @__PURE__ */ t.createElement(
        q,
        {
          color: m.colour || void 0,
          dataTestId: "fuse-product-card__promo-identifier",
          size: R,
          ...e == null ? void 0 : e.promoIdentifier,
          className: u(
            (S = e == null ? void 0 : e.promoIdentifier) == null ? void 0 : S.className,
            "fuse-product-card__promo-identifier"
          )
        },
        m.displayName
      ),
      /* @__PURE__ */ t.createElement("div", { className: _.productCard__imageSpacing }),
      /* @__PURE__ */ t.createElement(H, { swatches: z }),
      /* @__PURE__ */ t.createElement("div", { className: "productInfo" }, /* @__PURE__ */ t.createElement("div", { className: "persuasive-message" }), /* @__PURE__ */ t.createElement(
        g,
        {
          tag: "span",
          type: "paragraph",
          "data-testid": "fuse-product-card__brand",
          size: o,
          ...e == null ? void 0 : e.brand,
          className: u(
            _.productCard__brand,
            (h = e == null ? void 0 : e.brand) == null ? void 0 : h.className,
            "fuse-product-card__brand"
          )
        },
        C
      ), /* @__PURE__ */ t.createElement(
        g,
        {
          type: "heading",
          tag: "h3",
          "data-testid": "fuse-product-card__title",
          size: o,
          ...e == null ? void 0 : e.title,
          className: u(
            _.productCard__title,
            (x = e == null ? void 0 : e.title) == null ? void 0 : x.className,
            "fuse-product-card__title"
          )
        },
        v
      ), /* @__PURE__ */ t.createElement(
        j,
        {
          price: (a == null ? void 0 : a.current) || 0,
          headingTag: "h4",
          isEuro: a == null ? void 0 : a.isEuro,
          prevPrice: a == null ? void 0 : a.previous,
          saving: a == null ? void 0 : a.saving,
          showCurrentFrom: a == null ? void 0 : a.showCurrentPriceFrom,
          showPreviousFrom: a == null ? void 0 : a.showPreviousPriceFrom,
          showSave: a == null ? void 0 : a.showSave,
          size: $,
          dataTestId: "fuse-product-card__price",
          ...e == null ? void 0 : e.price,
          className: u(
            _.productCard__price,
            (N = e == null ? void 0 : e.price) == null ? void 0 : N.className,
            "fuse-product-card__price"
          )
        }
      ), c != null && c.rating ? /* @__PURE__ */ t.createElement(
        B,
        {
          rating: c == null ? void 0 : c.rating,
          reviewLinkText: c == null ? void 0 : c.reviewText,
          dataTestId: "fuse-product-card__rating",
          size: ee,
          ...e == null ? void 0 : e.rating
        }
      ) : null)
    ),
    (r == null ? void 0 : r.saveCallback) && typeof (r == null ? void 0 : r.saveCallback) == "function" && /* @__PURE__ */ t.createElement(
      G,
      {
        dataTestId: "fuse-product-card__save-for-later",
        showLabel: !1,
        saveLabel: `Save for later ${C} ${v}`,
        savedLabel: `Saved ${C} ${v}`,
        isSaved: r.isSaved,
        onClick: A,
        "aria-pressed": T,
        iconSize: ae,
        ...e == null ? void 0 : e.saveForLater,
        className: u(
          _.productCard__saveForLater,
          (E = e == null ? void 0 : e.saveForLater) == null ? void 0 : E.className,
          "fuse-product-card__save-for-later"
        )
      }
    )
  );
}
de.displayName = "ProductCard";
export {
  he as ListViewProductCard,
  de as ProductCard
};
